<template>
  <div v-scroll="handleScroll">
    <CategoryView/>
    <Basket :page="'catalog'" v-if="$store.getters.enableOrder"/>
    <div style="padding-bottom: 85px;"></div>
  </div>
</template>

<script>
  import {FETCH_PRODUCTS} from '@/store/actions.type'
  import Basket from '@/components/Default/Basket'
  import PopularProducts from '@/components/ECommerce/Products/PopularProducts'
  import CategoriesPreview from '@/components/ECommerce/Categories/CategoriesPreview'
  import CategoryView from '@/components/ECommerce/Categories/CategoryView'

  export default {
    name: 'Catalog',
    data() {
      return {
        FETCH_PRODUCTS
      }
    },
    components: {
      CategoryView,
      CategoriesPreview,
      PopularProducts,
      Basket
    },
    methods: {
      handleScroll: function () {
        let element = document.getElementsByClassName('nav_line_main')[0]
        if (element) {
          if (window.scrollY < 170) {
            element.classList.remove('nav_line_main_act')
          } else {
            element.classList.add('nav_line_main_act')
          }
        }
      }
    },
    mounted() {
    }
  }
</script>
